/* Etiqueta: botones de compra con redireccion directa (sin carrito), galeria, fecha de entrega. Sin dependencias. */
(function () {
  'use strict';

  var cfg = window.themeConfig || {};
  var offer = cfg.offer || { enabled: false, buy: 2, get: 1, unitsPerPack: 24 };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cap(str) { str = String(str || ''); return str.charAt(0).toUpperCase() + str.slice(1); }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    format = format || cfg.moneyFormat || '{{amount_with_comma_separator}} €';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function delimit(value, precision, thousands, decimal) {
      var fixed = (value / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(re);
    var out;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': out = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = delimit(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': out = delimit(cents, 2, ' ', ','); break;
      default: out = delimit(cents, 2, ',', '.');
    }
    return format.replace(re, out);
  }

  /* ---------- Product page: gallery, bundle builder ---------- */
  function initGallery(section) {
    var gallery = $('[data-gallery]', section);
    if (!gallery) return null;
    var slides = $$('.product__slide', gallery);
    var thumbs = $$('[data-thumb]', section);
    function go(index, smooth) {
      var slide = slides[index];
      if (!slide) return;
      gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    var ticking = false;
    gallery.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var i = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        ticking = false;
      });
    });
    return {
      showMedia: function (mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(mediaId)) { go(i); return; }
        }
      }
    };
  }

  function initProduct(section) {
    if (section.__ready) return;
    section.__ready = true;
    var gallery = initGallery(section);
    var bundleEl = $('[data-bundle]', section);
    var buyLink = $('[data-buy-link]', section);
    if (!buyLink) return;

    var addLabel = $('[data-add-label]', buyLink);
    var stickyLink = $('[data-sticky-link]', section);
    var stickyLabel = $('[data-sticky-label]', section);
    var slots = bundleEl ? $$('[data-slot]', bundleEl) : [];
    var offerRadios = bundleEl ? $$('[data-offer-radio]', bundleEl) : [];

    /* Chaque offre (1 pack / 3 packs) porte son prix et son lien dans le HTML. */
    function refresh() {
      var checked = offerRadios.filter(function (r) { return r.checked; })[0];
      offerRadios.forEach(function (r) {
        var card = r.closest('.offer-card');
        if (card) card.classList.toggle('is-selected', r.checked);
      });
      if (!checked) return;
      var q = parseInt(checked.value, 10) || 1;
      var url = checked.getAttribute('data-url');
      var total = Number(checked.getAttribute('data-total')) || 0;
      slots.forEach(function (slot, i) { slot.hidden = i >= q; });
      var label = 'Comprar ' + q + (q === 1 ? ' pack' : ' packs') + (total ? ' por ' + formatMoney(total) : '');
      if (url) {
        buyLink.setAttribute('href', url);
        if (stickyLink) stickyLink.setAttribute('href', url);
      }
      if (addLabel) addLabel.textContent = label;
      if (stickyLabel) stickyLabel.textContent = label;
    }

    offerRadios.forEach(function (r) { r.addEventListener('change', refresh); });
    slots.forEach(function (slot) {
      var sel = $('[data-slot-select]', slot);
      var img = $('[data-slot-img]', slot);
      if (!sel) return;
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (img && opt.getAttribute('data-img')) img.src = opt.getAttribute('data-img');
        if (gallery) gallery.showMedia(opt.getAttribute('data-media-id'));
      });
    });

    var sticky = $('[data-sticky-buy]', section);
    if (sticky && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }).observe(buyLink);
    }

    refresh();
  }

  /* ---------- Delivery date ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      added++;
    }
    return d;
  }
  function initDelivery() {
    $$('[data-delivery]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-days'), 10) || 3;
      var prefix = el.getAttribute('data-prefix');
      if (!prefix || typeof Intl === 'undefined') return;
      try {
        var text = new Intl.DateTimeFormat('es-ES', { weekday: 'long', day: 'numeric', month: 'long' })
          .format(addBusinessDays(new Date(), days));
        el.innerHTML = esc(prefix) + ' <strong>' + esc(text) + '</strong>';
      } catch (e) { /* deja el texto de respaldo */ }
    });
  }

  /* ---------- Carrousel d'avis ---------- */
  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(function (track) {
      var box = track.parentNode;
      var prev = $('[data-carousel-prev]', box);
      var next = $('[data-carousel-next]', box);
      function step(dir) {
        var card = track.firstElementChild;
        var w = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  /* ---------- Init ---------- */
  function init() {
    $$('[data-product-section]').forEach(initProduct);
    initCarousels(document);
    initDelivery();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (event) {
    $$('[data-product-section]', event.target).forEach(initProduct);
    initCarousels(event.target);
    initDelivery();
  });
})();
